import Card from "../../../../components/UI/Card";
import ShippingMethodsList from "./ShippingMethodsList";
import { useState} from "react";
import {useParams} from "react-router-dom";
import {checkFeatureAvailability} from "../../../../util/helper";
import {useDispatch, useSelector} from "react-redux";
import {setOrderForm} from "../../../../store/slices/orderSlice";
import TrackingNumber from "../TrackingNumber";

const SelectShippingMethods = ({errors,setValue, getValues}) => {
    const [shippingMethod, setShippingMethod] = useState(null)
    const [openModal, setModal] = useState(false)
    const params = useParams()
    const order = useSelector(state => state.orders.orderForm);
    const {orderForm} = useSelector(state => state.orders)
    const dispatch = useDispatch();
    const selectNewShipping = (row) => {
        setValue('shipping_cost', row.fee)
        setValue('shipping_method_id', row.id ? row.id : '')
        setShippingMethod(row)
        dispatch(setOrderForm({...orderForm, shipping_cost: row.fee, shipping_method_id:  row.id}))
    }
    const newErrors = Object.keys(errors).map((key) =>  key);

    return (
        <>
            <Card>
                <h1 className="common_sub_title d_flex_btwn mt_0 mb_5">
                    Shipping Methods
                    {checkFeatureAvailability(order, 'default', params) && <span className={'cursor_pointer fw_regular font_15p d_flex_center text_underline'}  onClick={()=>setModal(!openModal)}>Change Shipping Method</span>}
                </h1>

                {newErrors.includes('shipping_method_id') && <span className={'text_red'}>Please select Shipping method</span>}
                {shippingMethod &&
                    <div className="order_summery_table">
                        <table className="table border_none">
                            <tbody>
                            <tr>
                                <td className="text_left width_100p fw_600">Name</td>
                                <td>{shippingMethod.name} </td>
                            </tr>
                            <tr>
                                <td className="text_left fw_600">Courier</td>
                                <td>{shippingMethod.courier ? shippingMethod.courier.name : ''}</td>
                            </tr>
                            <tr>
                                <td className="text_left fw_600">Cost</td>
                                <td>${shippingMethod.fee ? shippingMethod.fee.toFixed(2) : '0.00'}</td>
                            </tr>
                            <TrackingNumber order={order} />

                            </tbody>
                        </table>
                    </div>
                }
            </Card>
            <ShippingMethodsList openModal={openModal} setModal={setModal}  setShippingMethod={selectNewShipping} setValue={setValue} />
        </>
    );
}

export default SelectShippingMethods